export default {
  scrollToBottom: 'Scroll to bottom of message thread',
};
